import request from '@/utils/request'
/**
 * @apiName 合同模板列表接口
 */
export function contractTemplateListApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改合同模板状态
 */
export function contractTemplateUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/template/updateState',
    method: 'POST',
    data,
  })
}
